import { useEffect } from 'react'
import { trackEvent } from 'analytics/trackFunctions'
// components
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import { LOAN_BANNER_STEPS } from 'constants/wording'
// assets
import TickIcon from 'components/listbox/SelectedIcon'
import advanceImg from 'assets/images/advance-modal.png'

interface FirstTimeInAdvanceSectionProps {
  setHasVisited: (s: boolean) => void
  alternativeFunction?: () => void | null
  isOpen: boolean
}

const FirstTimeInLoanSection = ({
  setHasVisited,
  alternativeFunction = null,
  isOpen
}: FirstTimeInAdvanceSectionProps) => {
  useEffect(() => {
    trackEvent({ eventName: 'bille_pantalla_informativo_prestamos' })
  }, [])

  return (
    <ModalContainer
      className='!max-w-[25rem] !p-0'
      isShown={isOpen}
      noCloseButton
      setModalFunction={() => {
        if (alternativeFunction) {
          return alternativeFunction()
        }
        return setHasVisited(true)
      }}
    >
      <div className='rounded-t-lg bg-advance-modal w-full'>
        <div className='pt-2'>
          <img className='mx-auto' src={advanceImg} alt='' />
        </div>
      </div>

      <div className='px-4 bg-gray-100'>
        <h2 className='text-center text-black font-bold px-2 text-xl leading-5'>
          Comprá eso que querés con un préstamo a la mejor tasa
        </h2>

        <div className='space-y-4 my-4 px-2 self-start'>
          {LOAN_BANNER_STEPS.map((item) => (
            <div key={item.number} className='flex gap-2 items-center '>
              <TickIcon className='w-6 h-6' />
              <p className='text-black text-left font-medium text-xs'>
                {item.description}
              </p>
            </div>
          ))}
        </div>

        <PrimaryButton
          buttonText='¡Empezar!'
          primaryButtonFunction={() => setHasVisited(true)}
          className='md:max-w-[18.5rem] max-w-full mx-auto mb-4 mt-8 md:mt-4'
        />
      </div>
    </ModalContainer>
  )
}

export default FirstTimeInLoanSection
